import React , {useState,useEffect} from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail } from 'lucide-react';
import { Link,useLocation } from 'react-router-dom';

const Footer = () => {
    const [homeLink, setHomeLink] = useState('/');
    const location = useLocation()
    useEffect(() => {
            const searchParams = new URLSearchParams(location.search);
            const utmSource = searchParams.get('utm_source');
            const utmMedium = searchParams.get('utm_medium');
            const utmCampaign = searchParams.get('utm_campaign');
            
            // Create a new URLSearchParams object for the beta link
            const betaParams = new URLSearchParams();
            
            // Add UTM parameters if they exist
            if (utmSource) betaParams.append('utm_source', utmSource);
            if (utmMedium) betaParams.append('utm_medium', utmMedium);
            if (utmCampaign) betaParams.append('utm_campaign', utmCampaign);
            
            // Construct the new beta link with UTM parameters
            const params = betaParams.toString();
            const newBetaLink = params ? `/?${params}` : '/';
            
            setHomeLink(newBetaLink);
        }, [location.search]);
    const currentYear = new Date().getFullYear();
    const primaryColor = '#6A5AE0';

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className="relative bg-white py-6 border-t border-gray-200 mt-auto">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-start">
                    <div className="flex flex-col md:flex-row items-start mb-4 md:mb-0 md:gap-8">
                        <div className="flex flex-col items-start mb-4 md:mb-0">
                            <div className="flex items-center gap-2 mb-1">
                                <Link to={homeLink} onClick={scrollToTop}>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/PrepAiro.png`}
                                        alt="PrepAiro Logo"
                                        className="w-8 h-8 object-contain"
                                    />
                                </Link>
                                <Link to={homeLink} onClick={scrollToTop}>
                                    <h3 className="Lexend, sans-serif " style={{
                                        color: '#3E3E3E', fontSize: '1.5rem',
                                        fontWeight: 'bold', letterSpacing: 1.2
                                    }}>
                                        PrepAiro
                                    </h3>
                                </Link>
                            </div>
                            <p className="text-sm poppins-regular text-gray-600 mt-1">Your Learning Partner</p>
                            <p className="text-xs font-bold mt-1" style={{color: primaryColor}}>
                                &copy; {currentYear} VerTune Data Technologies Private Limited. All Rights Reserved.
                            </p>
                        </div>
                        <div className="flex flex-col items-start mb-4 md:mb-0 md:ml-8">
                                <h5 className="Lexend, sans-serif " style={{
                                    color: '#3E3E3E', fontSize: '1.5rem',
                                    fontWeight: 'bold', letterSpacing: 1.2
                                }}>About Us
                                </h5>
                                <Link to="/privacy-policy"
                                      className="text-sm text-gray-600 hover:text-[#6A5AE0] transition-colors">
                                    Privacy Policy
                                </Link>
                                <Link to="/terms-of-service"
                                      className="text-sm text-gray-600 hover:text-[#6A5AE0] transition-colors">
                                    Terms & Conditions
                                </Link>
                        </div>
                    </div>
                    <div className="flex space-x-8 mb-4 md:mb-0">
                        {[
                            {icon: Facebook, href: 'https://www.facebook.com/profile.php?id=61573423407158'},
                            {icon: Twitter, href: 'https://x.com/PrepAiro' },
                            { icon: Instagram, href: 'https://www.instagram.com/prepairo.ai' },
                            { icon: Linkedin, href: 'https://www.linkedin.com/company/prepairo' },
                            { icon: Mail, href: 'mailto:info@prepairo.com' }
                        ].map((social, index) => (
                            <a
                                key={index}
                                href={social.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="transform hover:scale-110 transition-all duration-200 hover:opacity-80"
                                style={{ color: primaryColor }}
                            >
                                <social.icon size={24} />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;